module.exports = __webpack_public_path__ + "img/web_bottom_logo.69976321.png";